import './scss/index.scss'
import ButtonComponent from './ButtonComponent'

const ButtonPackage = {
    name: 'UIButton',
    configure(config) {
        config.addComponent('UIButton', ButtonComponent)
    }
}

export {ButtonPackage}
